class cOptionsEcommerce {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;

        var elCurrencyTable = $("#currency-table");
        $(elCurrencyTable).dataTable({
            'paging': false,
            'ordering': true,
            'info': true,
            'order': [[0, 'desc'], [3, 'asc']],
            'columnDefs': [
                { "orderable": false, "targets": [1, 4] }
            ],
            //Text translation options
            //Note the required keywords between underscores (e.g _MENU_)
            oLanguage: {
                sSearch: 'Search all columns:',
                sLengthMenu: '_MENU_ Sales per page',
                info: 'Showing page _PAGE_ of _PAGES_',
                zeroRecords: 'Nothing found - sorry',
                infoEmpty: 'No records available',
                infoFiltered: '(filtered from _MAX_ total records)'
            }
        });

        var elEditECommerceOptionsSubmitBtn = $("#edit-e-commerce-options-submit-btn");
        this.elECommerceOptionsEditForm = $('#ecommerce-form');
        $(elEditECommerceOptionsSubmitBtn).click(function (e) { return self.onEditECommerceOptionsSubmitBtnClick(this, e); });

        var elEditCreditsOptionsSubmitBtn = $('#edit-credit-options-submit-btn, .add-credit-options-btn');
        this.elCreditsOptionsEditForm = $('#credits-form');
        $(elEditCreditsOptionsSubmitBtn).click(function (e) { return self.onEditCreditsOptionsSubmitBtnClick(this, e); });

        $('.currencies').on('click', function (e) {
            self.onCurrencyClick(e.target);
        });
        $('.defaultCurrency').on('click', function (e) {
            self.onDefaultCurrencyClick(e.target);
        });
    }
    onEditECommerceOptionsSubmitBtnClick(btn, e) {
        $(btn).button('loading');

        $(this.elECommerceOptionsEditForm).ajaxSubmit({
            url: URL_ADMIN + '/options/main/updateecommerce/',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                } else {
                    notify.error(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
    }

    onEditCreditsOptionsSubmitBtnClick(btn, e) {
        $(btn).button('loading');
        $(this.elCreditsOptionsEditForm).ajaxSubmit({
            url: URL_ADMIN + '/options/main/updatecredits/',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                console.log(statusText, xhr, el);
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                } else {
                    notify.error(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
    }

    onCurrencyClick(el) {
        let currencyCode = el.dataset.currencyCode;
        let a = new cAjax(URL_ADMIN + '/options/main/togglecurrency', function (ret) {
            ret = JSON.parse(ret);
            if (ret.update == 'Added' || ret.update == 'Removed') {
                let same = $('.' + ret.code);
                let sameCode = $('.' + ret.code + '-code');
                for (let i = 0; i < same.length; i++) {
                    if (ret.update == 'Added') {
                        same[i].classList.replace('enable', 'disable');
                        same[i].classList.replace('btn-default', 'btn-success');
                        same[i].classList.replace('fa-toggle-off', 'fa-toggle-on');
                        sameCode[i].classList.add('bg-success');
                    } else if (ret.update == 'Removed') {
                        same[i].classList.replace('disable', 'enable');
                        same[i].classList.replace('btn-success', 'btn-default');
                        same[i].classList.replace('fa-toggle-on', 'fa-toggle-off');
                        sameCode[i].classList.remove('bg-success');
                    }
                }
                notify.success("Update saved");
            } else if (ret.update == 'Error') {
                notify.error("Error: update failed");
            }

        });
        if (el.classList.contains('fa-toggle-off')) {
            a.update('id=' + currencyCode + '&action=add', 'get');
        } else {
            a.update('id=' + currencyCode + '&action=remove', 'get');
        }
    }

    onDefaultCurrencyClick(el) {
        let defaultCurrency = el.value;
        let a = new cAjax(URL_ADMIN + '/options/main/updatedefaultcurrency', function (ret) {
            ret = ret ? JSON.parse(ret) : false;

            if (ret.update == 'OK') {
                notify.success("Default saved");
            } else if (ret.update == 'Error') {
                notify.error("Error: Default currency update failed");
            }
            location.reload();
            return false;
        });
        a.update('id=' + defaultCurrency, 'get');
    }
}